// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"de06c9e8","670":"4664a9f7"}[chunkId] + ".chunk.css";
};